import React, { useState } from 'react';
import './Search.css';
import {MagnifyingGlass, X} from '@phosphor-icons/react'

function RunSearch(q, setPrevSearch, setSearchQuery) {
    if(q != "") {
        setPrevSearch(q);
        setSearchQuery("");
        window.location.href = `/?search=${q}`;
    }
}

function submitSearch(e, setPrevSearch, setSearchQuery) {
    e.preventDefault();
    RunSearch(e.target[0].value, setPrevSearch, setSearchQuery);
}

const Search = (props) => {
    const [searchQuery, setSearchQuery] = useState("");
    const [prevSearch, setPrevSearch] = useState("Search ...");
    return (
        <form className={'Search search-main '+props.className} onSubmit={(e)=> submitSearch(e, setPrevSearch, setSearchQuery)}>
            <div className='SearchButton' onClick={()=>RunSearch(searchQuery, setPrevSearch, setSearchQuery)}>
                    <MagnifyingGlass size={25} />
            </div>
            <div className='SearchInput flex-1'>
                <input type="text" placeholder={prevSearch} onChange={e => {setSearchQuery(e.target.value)}} value={searchQuery}/>
            </div>
            <div className='d-flex align-center'>
                <div className={`CancelSearch`} onClick={()=>{setSearchQuery(""); setPrevSearch("Search...")}}>
                    <X size={20} className={`${!searchQuery && 'hidden'}`} />
                </div>

            </div>
        </form>
    );
};

export default Search;